package hk.com.vr360_demo2.webapp.component.viewer.component


import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.useState
import web.cssom.AlignItems
import web.cssom.Cursor
import web.cssom.Display
import web.cssom.FlexDirection
import web.cssom.NamedColor
import web.cssom.TextAlign
import web.cssom.px

external interface ShareButtonProps : Props {
    var label: String?
}

val ShareButton = FC<ShareButtonProps> { props ->
    val (showShare, setShowShare) = useState(false)

    div {
        css {
            display = Display.flex
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
            cursor = Cursor.pointer
            color = NamedColor.white
            gap = 4.px
        }
        onClick = { setShowShare(true) }

        img {
            src = "/assets/images/share.svg"
            alt = "分享"
            css {
                width = 24.px
                height = 24.px
//                asDynamic().filter = "brightness(0) invert(1)"
            }
        }

        div {
            css {
                fontSize = 14.px
                minWidth = 64.px
                textAlign = TextAlign.center
                asDynamic()["@media (max-width: 600px)"] = js("{}").unsafeCast<react.CSSProperties>().apply {
                    display = "none".unsafeCast<Display>()
                }
            }
            +(props.label ?: "分享")
        }
    }

    if (showShare) {
        ShareDialog {
            show = showShare
            url = ""
            onClose = { setShowShare(false) }
        }
    }
}
